package mo.web.portfoliofront.infrastructure.data

import mo.web.portfoliofront.infrastructure.models.Photo

val PHOTOS_LIST = listOf(

     Photo(
         imageUrl = "https://i.postimg.cc/K8wMJQXx/japaneseteagarden.jpg",
         alt = "Japanese Tea Garden",
         caption = "Japanese Tea Garden"
     ),

    Photo(
        imageUrl = "https://i.postimg.cc/Y0RFRH73/tahoeday.jpg",
        alt = "Lake Tahoe Mountains",
        caption = "Lake Tahoe Mountains"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/1XBFBQSK/pandaspotting.jpg",
        alt = "Panda",
        caption = "Panda"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/yxjRjHKj/murphygreed.jpg",
        alt = "Murphy's Greed",
        caption = "Murphy's Greed"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/yxs90NMv/pumpkinpretty.jpg",
        alt = "Pretty Pumpkin",
        caption = "Pretty Pumpkin"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/YCcxDbNK/deucemarley.jpg",
        alt = "Deuce & Marley",
        caption = "Deuce & Marley"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/YqL3xJWP/goldengatetrees.jpg",
        alt = "Golden Gate Trees",
        caption = "Golden Gate Trees"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/PxqbvcH7/graduated.jpg",
        alt = "USF Graduate",
        caption = "USF Graduate"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/3xMZfnj3/laketahoelake.jpg",
        alt = "Lake Tahoe Lake",
        caption = "Lake Tahoe Lake"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/mZm2TgmW/laketahoetrees.jpg",
        alt = "Lake Tahoe Trees",
        caption = "Lake Tahoe Trees"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/fWp7kBrx/mtdavidson.jpg",
        alt = "Mt.Davidson",
        caption = "Mt.Davidson"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/zGSTt5Xj/notbandwagon.jpg",
        alt = "Raiders 4 Lyfe",
        caption = "Raiders 4 Lyfe"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/SxpWfjqh/sanfrancisco1.jpg",
        alt = "San Francisco Skyline",
        caption = "San Francisco Skyline"
    ),

    Photo(
        imageUrl = "https://i.postimg.cc/vZL5qMHk/usfcathedral.jpg",
        alt = "USF Cathedral",
        caption = "USF Cathedral"
    ),

)
